export default __webpack_public_path__ + "25ead85b0511c49efc76bfb00b074378.png";